import api from '.';

export const condicaoVenda = async (empresaId, tabelaPrecoId, produtoId, pessoaId) => {
    try {
        const { data } = await api.get('/serviceMovimento', {
            params: {
                empresaId,
                tabelaPrecoId,
                produtoId,
                pessoaId,
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
/* obter os dados da tabelaPreco e dos itens na tabela*/
export const retornaTabelaPrecoItem = async (tabelaPrecoId, produtoId) => {
    try {
        const { data } = await api.get('/retornaTabelaPrecoItem', {
            params: { tabelaPrecoId, produtoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const retornaEmbalagensByProdutoId = async (empresaId, produtoId) => {
    try {
        const { data } = await api.get('/retornaEmbalagensByProdutoId', {
            params: { empresaId, produtoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const retornaTabelaPreco = async (tabelaPrecoId) => {
    try {
        const { data } = await api.get('/retornaTabelaPreco', {
            params: { tabelaPrecoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
/* movimentoItem */
export const listarFinanceiro = ({ start, size, filters, filtersMode, globalFilter, sorting, parceiroId, situacaoId }) =>
    api.get('/movimento/listarFinanceiro', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            parceiroId,
            situacaoId,
        },
    });
export const listarLancamentos = ({ start, size, filters, filtersMode, globalFilter, sorting, movimentoId }) =>
    api.get('/movimento/listarLancamentos', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            movimentoId,
        },
    });
export const listarProdutos = (start, size, filters, filtersMode, globalFilter, sorting, movimentoId) =>
    api.get('/movimento/listarProdutos', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            movimentoId,
        },
    });
export const listarProdutosPedido = ({
    start,
    size,
    filters,
    filtersMode,
    globalFilter,
    sorting,
    empresaId,
    movimentoUuid,
    movimentoId,
}) =>
    api.get('/movimento/listarProdutosPedido', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            empresaId,
            movimentoUuid,
            movimentoId,
        },
    });

export const listarProdutosTabelaPrecoPedido = ({
    start,
    size,
    filters,
    filtersMode,
    globalFilter,
    sorting,
    empresaId,
    movimentoUuid,
    movimentoId,
}) =>
    api.get('/movimento/listarProdutosTabelaPrecoPedido', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            empresaId,
            movimentoUuid,
            movimentoId,
        },
    });

export const deletarProduto = async (obj) => {
    try {
        const { data } = await api.post('/movimento/deletarProduto', obj);

        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const duplicidadeProduto = async (empresaId, movimentoId, produtoId, embalagemId) => {
    try {
        const { data } = await api.get('/movimento/duplicidadeProduto/', {
            params: { empresaId, movimentoId, produtoId, embalagemId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const managerProduto = async (novoProduto) => {
    try {
        const { data } = await api.post('/movimento/CreateOrEditProduto', novoProduto);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};

//obtem o movimentoItem
export const obterMovimentoItemByIdOrUUID = async (obj) => {
    try {
        const { data } = await api.post('/movimento/obterMovimentoItemByIdOrUUID', obj);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const obterMovimentoItemByConferenciaCodigo = async (obj) => {
    try {
        const { data } = await api.post('/movimento/obterMovimentoItemByConferenciaCodigo', obj);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
/* TERMO ADITIVO*/
export const duplicidadeAditivo = async (movimentoId, tipo, dataAditivo) => {
    try {
        const { data: result } = await api.get('/movimento/duplicidadeAditivo/', {
            params: { movimentoId, tipo, dataAditivo },
        });
        return result; // Retorna os dados ao chamador
    } catch (error) {
        console.error(error); // Loga qualquer erro que ocorrer
        throw error;
    }
};
export const managerAditivo = async (novoAditivo) => {
    try {
        const { data } = await api.post('/movimento/CreateOrEditAditivo', novoAditivo);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};
export const listarAditivos = (start, size, filters, filtersMode, globalFilter, sorting, movimentoId) =>
    api.get('/movimento/listarAditivos', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            movimentoId,
        },
    });
export const deletarAditivo = (uuid) => api.post('/movimento/deletarAditivo', { uuid });

/* conferência */
export const conferencia = async (novoProduto) => {
    try {
        const { data } = await api.post('/movimento/conferencia', novoProduto);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};

/* assinaturas no movimento */
export const listarAssinatura = ({ start, size, filters, filtersMode, globalFilter, sorting, movimentoId }) =>
    api.get('/movimento/listarAssinatura', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            movimentoId,
        },
    });
export const deletarAssinatura = (obj) => api.post('/movimento/deletarAssinatura', obj);

/* fretes no movimento */
export const listarFretes = ({
    start,
    size,
    filters,
    filtersMode,
    globalFilter,
    sorting,
    empresaId,
    movimentoUuid,
    movimentoId,
}) =>
    api.get('/movimento/listarFretes', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            empresaId,
            movimentoUuid,
            movimentoId,
        },
    });
export const managerFrete = async (obj) => {
    try {
        const { data } = await api.post('/movimento/managerFrete', obj);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};

//funções de estoque
export const calculaEstoques = (obj) => {
    if (!obj.produtoId) {
        return [];
    }
    const data = api.post('/movimento/calculaEstoques', obj);

    return data;
};
//função para obter o disponivel por situacao 16 disponivel
export const obterSaldo = (estoqueAgrupado, situacaoId = 16) => {
    if (!Array.isArray(estoqueAgrupado)) return 0;

    let total = 0;

    estoqueAgrupado.forEach((empresa) => {
        empresa.almoxarifados?.forEach((almox) => {
            const situacaoDisponivel = almox.saldos?.find((s) => s.situacaoId === situacaoId);
            if (situacaoDisponivel) {
                const entradas = Number(situacaoDisponivel.entradas || 0);
                const saidas = Number(situacaoDisponivel.saidas || 0);
                total += entradas - saidas;
            }
        });
    });

    return total;
};
export const obterSaldoDisponivel = (estoqueAgrupado) => {
    if (!Array.isArray(estoqueAgrupado)) return 0;

    let total = 0;

    estoqueAgrupado.forEach((empresa) => {
        empresa.almoxarifados?.forEach((almox) => {
            const saldoDisponivel = almox.saldos?.reduce((acc, saldo) => acc + (saldo.disponivel ?? 0), 0);
            total += saldoDisponivel;
        });
    });

    return total;
};

export const calculaValores = (produto, campo, natureza = 'saida') => {
    let {
        quantidade,
        precoBase,
        precoNegociado,
        precoPorUnidade,
        precoUnitario,
        valorUnitario,
        descontoPercentual,
        descontoValor,
        descontoFinanceiro,
        descontoFinanceiroPercentual,
        valorTotal,
        fator,
    } = produto;
    let pesoBruto = 0,
        pesoLiquido = 0,
        volume = 0;

    // Verifica se produto.Produto está definido e extrai valores
    if (produto.Produto) {
        pesoBruto = parseFloat(produto.Produto.pesoBruto) || 0;
        pesoLiquido = parseFloat(produto.Produto.pesoLiquido) || 0;
        volume = parseFloat(produto.Produto.volume) || 0;
    }

    // Converte os valores para números com valores padrão
    quantidade = parseFloat(quantidade);
    quantidade = Number.isFinite(quantidade) ? quantidade : 1;

    fator = parseFloat(fator);
    fator = Number.isFinite(fator) && fator > 0 ? fator : 1;

    precoBase = parseFloat(precoBase) || 0;
    precoNegociado = parseFloat(precoNegociado) || 0;
    precoPorUnidade = parseFloat(precoPorUnidade) || 0;
    precoUnitario = parseFloat(precoUnitario) || 0;
    valorUnitario = parseFloat(valorUnitario) || 0;

    descontoPercentual = parseFloat(descontoPercentual) || 0;
    descontoValor = parseFloat(descontoValor) || 0;

    descontoFinanceiro = parseFloat(descontoFinanceiro) || 0;
    descontoFinanceiroPercentual = parseFloat(descontoFinanceiroPercentual) || 0;

    valorTotal = parseFloat(valorTotal) || 0;

    // Calcula peso bruto, peso líquido e volume
    produto.pesoBruto = quantidade * pesoBruto;
    produto.pesoLiquido = quantidade * pesoLiquido;
    produto.volume = quantidade * volume;

    const baseBruta = quantidade * precoNegociado;

    if (['precoBase', 'quantidade', 'precoNegociado', 'descontoPercentual'].includes(campo)) {
        descontoValor = baseBruta * (descontoPercentual / 100);
        produto.descontoValor = descontoValor.toFixed(2);
    }

    if (campo === 'descontoValor') {
        descontoPercentual = baseBruta > 0 ? (descontoValor / baseBruta) * 100 : 0;
        produto.descontoPercentual = descontoPercentual.toFixed(2);
    }

    const totalLiquido = Math.max(baseBruta - descontoValor - descontoFinanceiro, 0);

    produto.valorTotal = totalLiquido.toFixed(2);

    produto.valorUnitario = quantidade > 0 ? (totalLiquido / quantidade).toFixed(2) : '0.00';

    produto.precoPorUnidade = fator > 0 ? (precoNegociado / fator).toFixed(2) : precoNegociado.toFixed(2);

    // Atualiza valores dependendo do campo alterado
    switch (campo) {
        case 'quantidade':
        case 'precoNegociado':
        case 'precoBase':
        case 'descontoPercentual':
        case 'descontoValor':
        case 'descontoFinanceiro':
        case 'descontoFinanceiroPercentual': {
            const baseBruta = quantidade * precoNegociado;

            if (campo === 'descontoPercentual') {
                descontoValor = baseBruta * (descontoPercentual / 100);
                produto.descontoValor = descontoValor.toFixed(2);
            }

            if (campo === 'descontoValor') {
                descontoPercentual = baseBruta > 0 ? (descontoValor / baseBruta) * 100 : 0;
                produto.descontoPercentual = descontoPercentual.toFixed(2);
            }

            if (campo === 'descontoFinanceiroPercentual') {
                descontoFinanceiro = baseBruta * (descontoFinanceiroPercentual / 100);
                produto.descontoFinanceiro = descontoFinanceiro.toFixed(2);
            }

            if (campo === 'descontoFinanceiro') {
                descontoFinanceiroPercentual = baseBruta > 0 ? (descontoFinanceiro / baseBruta) * 100 : 0;
                produto.descontoFinanceiroPercentual = descontoFinanceiroPercentual.toFixed(8);
            }

            const totalLiquido = Math.max(baseBruta - descontoValor - descontoFinanceiro, 0);

            produto.valorTotal = totalLiquido.toFixed(2);

            produto.valorUnitario = quantidade > 0 ? (totalLiquido / quantidade).toFixed(2) : '0.00';

            produto.precoPorUnidade = fator > 0 ? (precoNegociado / fator).toFixed(2) : precoNegociado.toFixed(2);

            break;
        }

        case 'valorTotal': {
            precoNegociado = quantidade > 0 ? valorTotal / quantidade : 0;

            produto.precoNegociado = precoNegociado.toFixed(2);
            produto.valorUnitario = quantidade > 0 ? (valorTotal / quantidade).toFixed(2) : '0.00';
            produto.precoPorUnidade = fator > 0 ? (precoNegociado / fator).toFixed(2) : precoNegociado.toFixed(2);

            break;
        }

        default: {
            const baseBruta = quantidade * precoNegociado;
            const totalLiquido = Math.max(baseBruta - descontoValor - descontoFinanceiro, 0);

            produto.valorTotal = totalLiquido.toFixed(2);
            produto.valorUnitario = quantidade > 0 ? (totalLiquido / quantidade).toFixed(2) : '0.00';
            produto.precoPorUnidade = fator > 0 ? (precoNegociado / fator).toFixed(2) : precoNegociado.toFixed(2);

            break;
        }
    }

    return produto; // Retorna o produto atualizado para o estado
};
export const recalcularCustos = async (movimentoId) => {
    try {
        const { data } = await api.post(`/movimento/recalcularCustos/${movimentoId}`);

        return data;
    } catch (error) {
        console.error(error);

        return (
            error?.response?.data || {
                message: 'Erro inesperado ao recalcular os custos.',
                type: 'error',
            }
        );
    }
};
export const somaFrete = (frete, campo) => {
    let { valorFrete, valorSeguro, valorPedagio, valorOutros, valorAlimentacao, valorTotal, valorEntrada } = frete;

    // Converte os valores para números com valores padrão
    valorFrete = parseFloat(valorFrete ?? 0);
    valorSeguro = parseFloat(valorSeguro ?? 0);
    valorPedagio = parseFloat(valorPedagio ?? 0);
    valorOutros = parseFloat(valorOutros ?? 0);
    valorAlimentacao = parseFloat(valorAlimentacao ?? 0);
    valorTotal = parseFloat(valorTotal ?? 0);
    valorEntrada = parseFloat(valorEntrada ?? 0);

    // Atualiza valores dependendo do campo alterado
    switch (campo) {
        case 'valorFrete':
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
            break;
        case 'valorSeguro':
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
            break;
        case 'valorPedagio':
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
            break;
        case 'valorOutros':
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
            break;
        case 'valorAlimentacao':
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
            break;
        default:
            frete.valorTotal = (valorFrete + valorSeguro + valorPedagio + valorOutros + valorAlimentacao).toFixed(2);
    }

    return frete;
};

// retorna o movimeno completo
export const movimentoFullByIdOrUUID = async (obj) => {
    try {
        const { data } = await api.post('/movimento/movimentoFullByIdOrUUID', obj);
        return data;
    } catch (error) {
        console.error(error);
        return (
            error?.response?.data || {
                message: 'Erro inesperado',
                type: 'error',
            }
        );
    }
};

/* rotina de comprovantes */
export const listarComprovantes = (start, size, filters, filtersMode, globalFilter, sorting, uuid) =>
    api.get('/movimento/listarComprovantes', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            uuid,
        },
    });
export const createOrEditComprovante = async (objeto) => {
    try {
        const { data } = await api.post('/movimento/createOrEditComprovante', objeto, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    } catch (error) {
        return error;
    }
};

/* operações fiscais */

/* fluxo oficial da Distribuição DF-e */
export const importarDocumentoFiscalDistribuido = async ({ distribuicaoFiscalDocumentoResumoId, is_cEANTrib = false }) => {
    try {
        const { data } = await api.post('/movimento/importarDocumentoFiscalDistribuido', {
            distribuicaoFiscalDocumentoResumoId,
            is_cEANTrib,
        });

        return data;
    } catch (error) {
        console.error('Erro ao importar documento fiscal:', {
            message: error?.response?.data?.message || error?.message,
            status: error?.response?.status,
            code: error?.response?.data?.code,
        });

        return (
            error?.response?.data || {
                message: 'Erro inesperado ao importar documento fiscal.',
                type: 'error',
                code: 'ERRO_IMPORTACAO_DOCUMENTO_FISCAL',
            }
        );
    }
};
export const listarHistoricoCustosProduto = async ({
    empresaId,
    produtoId,
    limite = 10,
    movimentoIdIgnorar,
    movimentoItemIdIgnorar,
}) => {
    const response = await api.get('/movimento/HistoricoCustosProduto', {
        params: {
            empresaId,
            produtoId,
            limite,
            movimentoIdIgnorar,
            movimentoItemIdIgnorar,
        },
    });

    return response.data;
};

/* Rotina de BALANÇO */
export const iniciarBalanco = (body) => api.post('/movimento/iniciarBalanco', body);

export const listarItensBalanco = ({ movimentoUuid, movimentoId, start = 0, size = 50 }) =>
    api.get('/movimento/listarItensBalanco', {
        params: {
            movimentoUuid,
            movimentoId,
            start,
            size,
        },
    });

export const listarProdutosBalanco = ({
    empresaId,
    almoxarifadoId,
    categoria = 'produto',
    filters = '[]',
    filtersMode = '{}',
    sorting = '[]',
}) =>
    api.get('/movimento/listarProdutosBalanco', {
        params: {
            empresaId,
            almoxarifadoId,
            categoria,
            filters,
            filtersMode,
            sorting,
            globalFilter: '',
        },
    });
export const salvarContagemBalanco = (payload) => api.post('/movimento/salvarContagemBalanco', payload);
export const conferirItensBalanco = (payload) => api.post('/movimento/conferirItensBalanco', payload);
export const aplicarBalanco = (payload) => api.post('/movimento/aplicarBalanco', payload);
